import { StoreAction } from "../../@core/constants/action";
import { isUserLoggedIn } from "../../utility/Utils";

const initialState = {
  activeChat: 0,
  allChatList: {}, // side-bar chat list
  selectedChat: {}, // Selected Chat
  entities: {},
  setActiveTab: isUserLoggedIn()?.u_type === 1 ? 1 : 3,
  tabs: {
    1: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
    2: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
    3: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
  },
  filterTabs: {
    1: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
    2: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
    3: { ids: [], pagination: { page: 1, hasMore: true, isLoading: false } },
  },
  lastReadChatId: 0,
  filterQuery: {},
  chatListCounters: {
    all_counter: 0,
    pending_counter: 0,
    my_chat_counter: 0,
    filter_all_counter: 0,
    filter_pending_counter: 0,
    filter_my_chat_counter: 0,
  },
  chatFilter: false,
  chatSideBar: false,
  chatLoading: false,
  getChatList: false, // Track Chat list get or not
  scrollAdjust: false, // Scroll adjust on every render
  stopScrolling: false,
  scrollLoading: false, // Scroll Loader show in selected chat
  isSendMessage: false, // Send Message Button disable
  userDetailSidebar: false,
  nonMetaChatMessages: {}, // { customerId: [mapped messages] }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.SET_ACTIVE_CHAT:
      return { ...state, activeChat: action.payload };
    case StoreAction.SET_CHAT_FILTER:
      return { ...state, chatFilter: action.payload };
    case StoreAction.SET_GET_CHAT_LIST:
      return { ...state, getChatList: action.payload };
    case StoreAction.SET_CHAT_LOADING:
      return { ...state, chatLoading: action.payload };
    case StoreAction.SET_CHAT_SIDE_BAR:
      return { ...state, chatSideBar: action.payload };
    case StoreAction.GET_ALL_CHAT_LIST:
      return { ...state, allChatList: action.payload };
    case StoreAction.SET_SCROLL_ADJUST:
      return { ...state, scrollAdjust: action.payload };
    case StoreAction.SET_SELECTED_CHAT:
      return { ...state, selectedChat: action.payload };
    case StoreAction.SET_IS_SEND_MESSAGE:
      return { ...state, isSendMessage: action.payload };
    case StoreAction.SET_SCROLL_LOADING:
      return { ...state, scrollLoading: action.payload };
    case StoreAction.SET_STOP_SCROLLING:
      return { ...state, stopScrolling: action.payload };
    case StoreAction.SET_USER_DETAILS_SIDEBAR:
      return { ...state, userDetailSidebar: action.payload };

    case StoreAction.SET_TAB_CHAT_LIST: {
      const { tab, chatList, append = false, pageNumber } = action.payload;

      const newChats = Object.values(chatList);
      const newIds = newChats.map((c) => c.waba_c_id);

      newChats.forEach((chat) => {
        const key = `waba_${chat.waba_c_id}`;

        state.entities[key] = {
          ...(state.entities[key] || {}),
          ...chat,
        };
      });

      const tabState = state.tabs[tab];
      const prevIds = tabState.ids;

      const updatedIds = append
        ? [...prevIds, ...newIds.filter((id) => !prevIds.includes(id))]
        : newIds;

      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tab]: {
            ...tabState,
            ids: updatedIds,
            pagination: {
              ...tabState.pagination,
              page: append
                ? tabState.pagination.page + 1
                : pageNumber?.pageNumber || 1,
              isLoading: false,
              hasMore: newIds.length > 0,
            },
          },
        },
      };
    }

    case StoreAction.SET_TAB_FILTER_LIST: {
      const { tab, chatList, append = false, pageNumber } = action.payload;

      const newChats = Object.values(chatList);
      const newIds = newChats.map((c) => c.waba_c_id);

      newChats.forEach((chat) => {
        const key = `waba_${chat.waba_c_id}`;

        state.entities[key] = {
          ...(state.entities[key] || {}),
          ...chat,
        };
      });

      const tabState = state.filterTabs[tab];
      const prevIds = tabState.ids;

      const updatedIds = append
        ? [...prevIds, ...newIds.filter((id) => !prevIds.includes(id))]
        : newIds;

      return {
        ...state,
        filterTabs: {
          ...state.filterTabs,
          [tab]: {
            ...tabState,
            ids: updatedIds,
            pagination: {
              ...tabState.pagination,
              page: append
                ? tabState.pagination.page + 1
                : pageNumber?.pageNumber || 1,
              isLoading: false,
              hasMore: newIds.length > 0,
            },
          },
        },
      };
    }

    case StoreAction.SET_CHAT_LIST_COUNTERS:
      return {
        ...state,
        chatListCounters: {
          ...state.chatListCounters,
          ...action.payload,
        },
      };

    case StoreAction.FILTER_QUERY:
      return {
        ...state,
        filterQuery: {
          ...state.filterQuery,
          ...action.payload,
        },
      };

    case StoreAction.CLEAR_FILTER_TAB_CHAT:
      return {
        ...state,
        filterTabs: Object.keys(state.filterTabs).reduce((acc, tab) => {
          acc[tab] = {
            ...state.filterTabs[tab],
            ids: [],
            pagination: {
              page: 1,
              hasMore: true,
              isLoading: false,
            },
          };
          return acc;
        }, {}),
        chatListCounters: {
          ...state.chatListCounters,
          filter_all_counter: 0,
          filter_pending_counter: 0,
          filter_my_chat_counter: 0,
        },
      };
    case StoreAction.UPDATE_CHAT_TAGS: {
      const { key, c_tags } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            c_tags,
          },
        },
      };
    }

    case StoreAction.UPDATE_CHAT_BLOCK: {
      const { key, c_block } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            c_block,
          },
        },
      };
    }

    case StoreAction.UPDATE_CHAT_MUTE: {
      const { key, c_mute } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            c_mute,
          },
        },
      };
    }

    case StoreAction.UPDATE_CHAT_STATUS: {
      const { key, c_chat_status } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            c_chat_status,
          },
        },
      };
    }

    case StoreAction.CLEAR_CHAT_MESSAGES: {
      const { key } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            message: [],
            last_message_time: null,
            last_message: null,
          },
        },
      };
    }

    case StoreAction.DELETE_MESSAGE: {
      const { key, newMessages } = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: {
            ...state.entities[key],
            message: newMessages,
          },
        },
      };
    }

    case StoreAction.UPDATE_ENTITIES:
      return {
        ...state,
        entities: { ...action.payload },
      };

    case StoreAction.UPDATE_TABS:
      const {
        isApplyFilter,
        newTabs,
        updatedEntities,
        newFilterTabs = null,
      } = action.payload;

      if (isApplyFilter) {
        return {
          ...state,
          filterTabs: newFilterTabs ? newFilterTabs : newTabs,
          tabs: newTabs,
          entities: updatedEntities,
        };
      }
      // else {
      return {
        ...state,
        tabs: newTabs,
        entities: updatedEntities,
      };
    // }

    case StoreAction.LAST_READ_CHAT_ID:
      return { ...state, lastReadChatId: action.payload };

    case StoreAction.SET_ACTIVE_TAB:
      return { ...state, setActiveTab: action.payload };
    case StoreAction.SET_NON_META_CHAT_MESSAGES: {
      const { customerId, messages } = action.payload;
      const existing = state.nonMetaChatMessages[customerId] || [];
      const merged = [...existing, ...messages]
        .reverse()
        .filter(
          (msg, index, arr) =>
            arr.findIndex((m) => String(m?.id) === String(msg?.id)) === index
        )
        .reverse();
      return {
        ...state,
        nonMetaChatMessages: {
          ...state.nonMetaChatMessages,
          [customerId]: merged,
        },
      };
    }

    case StoreAction.APPEND_NON_META_SENT_MESSAGE: {
      const { customerId, message } = action.payload;
      const existing = state.nonMetaChatMessages[customerId] || [];
      const cleaned = existing.filter((msg) => {
        const isSameId =
          String(msg.id) === String(message.id) ||
          (msg.messageId !== undefined &&
            String(msg.messageId) === String(message.id));
        if (isSameId) return false;
        const isManualForSameSend =
          String(msg.id).startsWith("manual-") &&
          Number(msg.status) === 0 &&
          (message.agent_id === undefined ||
            message.agent_id === null ||
            String(msg.userId) === String(message.agent_id)) &&
          msg.message === message.message;
        return !isManualForSameSend;
      });
      const merged = [...cleaned, message];
      return {
        ...state,
        nonMetaChatMessages: {
          ...state.nonMetaChatMessages,
          [customerId]: merged,
        },
      };
    }

    case StoreAction.UPDATE_NON_META_MESSAGE_STATUS:
      return {
        ...state,
        nonMetaChatMessages: action.payload?.nonMetaChatMessages,
      };
    default:
      return state;
  }
}
